// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"b9eaeecc","102":"6a8bd923","147":"8eabd9b4","242":"2008cce4","438":"c416f837","631":"5d8b852e","798":"d5f5de24"}[chunkId] + ".chunk.js";
};